export const VALUES_TABLE_LABELS = {
	TABLE_TITLE: 'Label values',
	TABLE_CAPTION: 'Table of label values with dashboard visibility toggles',
	COLUMN_VALUE: 'Value',
	COLUMN_DASHBOARD_VISIBILITY: 'Include in Dashboard Data',
	COLUMN_DASHBOARD_VISIBILITY_TOOLTIP:
		'Controls whether this value appears in dashboard reports and filters',
	COLUMN_ACTIONS: 'Actions',
	REMOVE_BUTTON_ARIA: 'Remove value',
	TOGGLE_VISIBLE_ARIA: 'Toggle dashboard visibility',
	EMPTY_STATE: 'No values added yet'
} as const;
